"use strict";

// Смена ссылки на счет

var update_invoice_link = function (lnk, val) {
    var cur_href = lnk.getAttribute("href");
    cur_href = cur_href.replace(/\?amount=([0-9]+)/, "?amount=" + val);
    lnk.setAttribute("href", cur_href);
};

function updateInvoiceLink(event) {
    const amount = event.target.value;
    update_invoice_link(document.querySelector(".js-invoice-link"), amount);
}

document.querySelector(".js-payment-amount").addEventListener("change", updateInvoiceLink);

export default {};
